import React, { useState, useEffect, useRef } from 'react';
import { FaInfoCircle, FaUserCircle, FaSignOutAlt } from 'react-icons/fa';
import piggyBankImage from '../assets/images/piggybank.png';
import About from './About';
import Auth from './Auth';
import './Header.css';

const API = 'https://piggybank-api.andresnicolas.com/routes';

function Header({ onLogin, onLogout }) {
  const [showAbout, setShowAbout] = useState(false);
  const [showAuth, setShowAuth] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [username, setUsername] = useState(() => localStorage.getItem('username') || null);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowUserMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleLogin = (name) => {
    setUsername(name);
    if (onLogin) onLogin(name);
  };

  const handleLogout = async () => {
    try {
      await fetch(`${API}/logout.php`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch {}
    localStorage.removeItem('username');
    setUsername(null);
    setShowUserMenu(false);
    if (onLogout) onLogout();
  };

  return (
    <>
      <div className="header-container">
        <div className="header-icons">
          <div className="header-user-wrap" ref={menuRef}>
            <button
              className={`header-info-btn ${username ? 'logged-in' : ''}`}
              onClick={() => username ? setShowUserMenu(!showUserMenu) : setShowAuth(true)}
              title={username ? username : 'Sign in'}
            >
              <FaUserCircle size={18} />
            </button>
            {username && showUserMenu && (
              <div className="user-menu">
                <span className="user-menu-name">@{username}</span>
                <button className="user-menu-logout" onClick={handleLogout}>
                  <FaSignOutAlt size={13} /> Sign out
                </button>
              </div>
            )}
          </div>
          <button className="header-info-btn" onClick={() => setShowAbout(true)} title="About">
            <FaInfoCircle size={18} />
          </button>
        </div>

        <img src={piggyBankImage} alt="Piggy Bank" className="header-logo" />
        <h1 className="header-title">
          <span className="title-text">
            <span className="piggy">Piggy</span>
            <span className="bank">Bank</span>
          </span>
        </h1>
        <p className="header-subtitle">Control your finances easily</p>
      </div>

      {showAbout && <About onClose={() => setShowAbout(false)} />}
      {showAuth && <Auth onClose={() => setShowAuth(false)} onLogin={handleLogin} />}
    </>
  );
}

export default Header;